import { FastshiftTeamCard } from "../../cards/fastshift-team-card";
import { SupportEngineersCard } from "../../cards/support-engineers-card";
import { RawRelationships } from "../../types";
import { mapRelationships, filterEngineers } from "../../utils";
import { BaseRelationshipsSection } from "../base-relationships-section";

export const InternalRelationshipsSection = ({
    relationships
}: {
    relationships: RawRelationships;
}) => {
    const relationshipMapping = mapRelationships(relationships);
    const engineers = filterEngineers(relationships);

    return (
        <BaseRelationshipsSection>
            <FastshiftTeamCard relationships={relationshipMapping} />
            <SupportEngineersCard engineers={engineers} />
        </BaseRelationshipsSection>
    );
};
